/** @deprecated Just use {@link crypto.randomUUID} directly */
const createUUID = globalThis.crypto.randomUUID.bind(globalThis.crypto);

export default createUUID;
